import { Plan } from './plan.model'

import { BaseModel } from '@shared/models/base.model'
import { User } from '@shared/models/user.model'
import { Team } from './team.model'

export class Client extends BaseModel {
  id: number
  name: string
  legalName: string
  taxNr: string
  chevronAccountId: string
  status: ClientStatus
  country?: string
  plan: Plan
  planId: string
  legalAddress: string
  billingAddress: string
  contractMonths: number | null
  invoiceDueDays: number | null
  createdAt: any
  keyContact: User
  keyContactId: string
  manager: Pick<User, 'fullName' | 'id' | 'name' | 'surname' | 'email' | 'phone' | 'role' | 'status' | 'lastLoggedAt'>
  salesManager: Pick<User, 'fullName' | 'id' | 'name' | 'surname' | 'email' | 'phone' | 'role' | 'status' | 'lastLoggedAt'>
  accountingContact: Pick<User, 'id' | 'name' | 'surname' | 'email' | 'phone' | 'role' | 'status' | 'lastLoggedAt' | 'driverSensorId'>
  timezone: string
  adminNote: string
  expirationDate: string
  clientNote: string
  notes: any
  team: Team
  updatedBy: Pick<User, 'fullName' | 'id' | 'name' | 'surname' | 'email' | 'phone' | 'role' | 'status' | 'lastLoggedAt'>
  createdByName: string
  statuses: any
  usersCount: number
  activeUsersCount: number
  vehiclesCount: number
  activeVehiclesCount: number
  devicesCount: number
  activeDevicesCount: number
  language: string
  billingPlanId: number
  isManualPayment: boolean
  oldestInvoiceId: number
  allowManualPayment: boolean
  waed?: string

  constructor(src?: Client) {
    super(src)

    this.manager = this.manager && new User(this.manager)
    this.salesManager = this.salesManager && new User(this.salesManager)
  }
}

export enum ClientStatus {
  Client = 'client',
  Potential = 'potential',
  Closed = 'closed',
  Blocked = 'blocked',
  Deleted = 'deleted',
  Demo = 'demo',
  PartiallyBlockedBilling = 'partially_blocked_billing',
  BlockedBilling = 'blocked_billing',
  BlockedOverdue = 'blocked_overdue',
}
